<template>
    <div class="detail" v-if="vo">
        <p>
            <img v-for="img in vo.imgs" :src="img"/>
        </p>
        <div class="opt">
            <yd-flexbox>
                <yd-flexbox-item class="opt-item" @click.native="closePage">&lt; 返回活动页</yd-flexbox-item>
                <yd-flexbox-item class="opt-item opt-item2" @click.native="closePage">选购该商品</yd-flexbox-item>
            </yd-flexbox>
        </div>
    </div>
</template>

<script>
    export default {
        name: "teaDetail",
        data(){
            return {
                vo:null,
                cof:{
                    1:{
                        title:'有影の小青柑',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/11@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/1/12@2x.png',
                        ]
                    },
                    2:{
                        title:'有影の普洱茶',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/2/11@2x.png',
                        ]
                    },
                    3:{
                        title:'有影の单丛茶',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/11@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/3/12@2x.png',
                        ]
                    },
                    4:{
                        title:'有影の大红袍',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/4/11@2x.png',
                        ]
                    },
                    5:{
                        title:'有影の铁观音',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/11@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/5/12@2x.png',
                        ]
                    },
                    6:{
                        title:'有影の红茶',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/11@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/12@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/6/13@2x.png',
                        ]
                    },
                    7:{
                        title:'有影の绿茶',
                        imgs :[
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/01@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/02@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/03@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/04@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/05@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/06@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/07@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/08@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/09@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/10@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/11@2x.png',
                            'https://cdn-yp.yymedias.com/public/APP/img/Activity/tea/detail/7/12@2x.png',
                        ]
                    },
                }

            };
        },
        created(){
            if (!this.$route.params.id || !this.cof[this.$route.params.id]) {
                this.$dialog.alert({mes:'商品不存在，或者已经下架',callback:()=>{this.$yymd.close();}}); return;
            }
            this.vo = this.cof[this.$route.params.id];
            document.title = this.vo.title;
        },
        methods:{
            closePage(){
                this.$yymd.close();
            },
        }
    }
</script>

<style scoped>
    .detail p {line-height: 0;}
    .detail img{ max-width: 100%;}
    .opt {
        position:fixed;
        bottom:0;left:0;width:100%;
        box-shadow: #ddd 0 0 1px ;
    }
    .opt-item {
        text-align: center;
        background-color:#fff;line-height: 1rem;
    }
    .opt-item2 {
        background-color: #FFD000;
    }
</style>